import {api} from "./api";

export const agree = () => {
    api.get('information/information&information_id=5').then(async (response) => {
        const text = await response.text()
        const myDiv = text.match(/<article class="w-full prose-lg">(.*)<\/article>/sg)
        window.dispatchEvent(new CustomEvent('modal', {
            detail: {
                message: myDiv[0],
                title: ' '
            }
        }))
    })
}